import React, { useState } from 'react';
import './ConfirmExitModalContent.css';
import { resolveModalTask } from '../modalTaskRegistry';

function ConfirmExitModalContent({ onClose, taskId }) {
  const [isProcessing, setIsProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSaveAndExit = async () => {
    const task = taskId ? resolveModalTask(taskId) : null;
    if (!task || isProcessing) return;
    setIsProcessing(true);
    setErrorMessage('');
    try {
      const result = await task('save');
      if (result === false) {
        throw new Error('SAVE_FAILED');
      }
      onClose();
    } catch (err) {
      console.error('[ConfirmExitModalContent] Unable to save before exit', err);
      setErrorMessage('No se pudo guardar el proyecto. Inténtalo nuevamente.');
      setIsProcessing(false);
    }
  };

  const handleExitWithoutSave = () => {
    if (isProcessing) return;
    const task = taskId ? resolveModalTask(taskId) : null;
    if (task) {
      task('exit');
    }
    onClose();
  };

  return (
    <div className="confirm-exit-modal">
      <button
        type="button"
        className="confirm-exit-modal__close"
        aria-label="Cerrar"
        onClick={onClose}
      >
        ×
      </button>
      <h2 className="confirm-exit-modal__title">¿Volver al panel de proyectos?</h2>
      <p className="confirm-exit-modal__subtitle">
        Puedes guardar tu trabajo antes de salir o continuar sin guardar.
      </p>
      {errorMessage ? (
        <div className="confirm-exit-modal__error" role="alert">
          {errorMessage}
        </div>
      ) : null}
      <div className="confirm-exit-modal__actions">
        <button
          type="button"
          className="confirm-exit-modal__button confirm-exit-modal__button--primary"
          onClick={handleSaveAndExit}
          disabled={isProcessing}
        >
          {isProcessing ? 'Guardando...' : 'Guardar y salir'}
        </button>
        <button
          type="button"
          className="confirm-exit-modal__button confirm-exit-modal__button--secondary"
          onClick={handleExitWithoutSave}
          disabled={isProcessing}
        >
          Salir sin guardar
        </button>
      </div>
    </div>
  );
}

export default ConfirmExitModalContent;
